import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import PlansSection from "../components/PlansSection";
import HowItWorks from "../components/HowItWorks";
import Testimonials from "../components/Testimonials";
import AboutSection from "../components/AboutSection";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import ScrollAnimation from "../components/ScrollAnimation";

function Home() {
  return (
    <div id="top">
      <Navbar />
      <HeroSection />
      <ScrollAnimation delay={0}><PlansSection /></ScrollAnimation>
      <ScrollAnimation delay={0}><HowItWorks /></ScrollAnimation>
      <ScrollAnimation delay={0}><Testimonials /></ScrollAnimation>
      <ScrollAnimation delay={0}><AboutSection /></ScrollAnimation>
      <ScrollAnimation delay={0}><FAQ /></ScrollAnimation>
      <Footer />
    </div>
  );
}

export default Home;